import { getFrontAppList, findAppInfo, findAuthedSchoolList } from '@/service/api';
import { IFrontApplicationState, IApplicationTable, SHELF_STATE, IApplication, IAuthSchool, DATAPUSH_STATE } from "@/typings/application";
import { EXAMINE_STATE } from '@/typings/factory';
import { Module } from "vuex";
import { IGlobalState } from "..";
import * as Types from '../action-types';

const state: IFrontApplicationState = {
    keyWord: "",
    shelfState: SHELF_STATE.ONSHELF,
    applications: {
        page: 1,
        limit: 10,
        page_count: 0,
        total_rows: 0,
        rows: []
    },
    application: {
        id: "",
        title: "",
        logo: "",
        introduce: "",
        screenshot: "",
        categoryCode: "",
        categoryName: "",
        examineState: EXAMINE_STATE.NOEXAMINE,
        shelfState: SHELF_STATE.NOSHELF,
        systemType: "",
        terminalType: "",
        secret: "",
        redirectUrl: "",
        dataPushUrl: "",
        dataPushExamineState: DATAPUSH_STATE.NOEXAMINE,
        useUserType: "",
        useScene: ""
    },
    authSchool: {
        authType: -1,
        keyWord: "",
        examineState: -1,
        page: 1,
        limit: 10,
        page_count: 0,
        total_rows: 0,
        rows: []
    }
};

const frontApp: Module<IFrontApplicationState, IGlobalState> = {
    namespaced: true,
    state,
    mutations: {
        [Types.SET_APPLICATION_PAGE](state, payload) {
            state.applications.page = payload;
        },
        [Types.SET_APPLICATION_LIST](state, payload: IApplicationTable) {
            state.applications.rows = payload.rows;
            state.applications.page_count = payload.page_count;
            state.applications.total_rows = payload.total_rows;
        },
        [Types.SET_APPLICATION_INFO](state, payload: IApplication) {
            state.application.id = payload.id;
            state.application.title = payload.title;
            state.application.logo = payload.logo;
            state.application.introduce = payload.introduce;
            state.application.screenshot = payload.screenshot;
            state.application.categoryCode = payload.categoryCode;
            state.application.categoryName = payload.categoryName;
            state.application.examineState = payload.examineState;
            state.application.shelfState = payload.shelfState;
            state.application.systemType = payload.systemType;
            state.application.terminalType = payload.terminalType;
            state.application.secret = payload.secret;
            state.application.redirectUrl = payload.redirectUrl;
            state.application.dataPushUrl = payload.dataPushUrl;
            state.application.dataPushExamineState = payload.dataPushExamineState;
            state.application.useUserType = payload.useUserType;
            state.application.useScene = payload.useScene;
        },
        [Types.SET_APPLICATION_AUTHED_SCHOOL_LIST](state, payload: IAuthSchool) {
            state.authSchool.rows = payload.rows;
            state.authSchool.page_count = payload.page_count;
            state.authSchool.total_rows = payload.total_rows;

        },
        [Types.SET_APPLICATION_AUTHED_SCHOOL_PAGE](state, payload) {
            state.authSchool.page = payload;
        }
    },
    actions: {
        // 设置应用列表
        async [Types.SET_APPLICATION_LIST]({ commit }, params) {
            const result = await getFrontAppList(params);
            commit(Types.SET_APPLICATION_LIST, result.data);
        },
        // 设置当前应用信息
        async [Types.SET_APPLICATION_INFO]({ commit }, params) {
            const result = await findAppInfo(params);
            commit(Types.SET_APPLICATION_INFO, result.data);
        },
        // 获取应用下已授权学校列表
        async [Types.SET_APPLICATION_AUTHED_SCHOOL_LIST]({ commit }, params) {
            const result = await findAuthedSchoolList(params);
            commit(Types.SET_APPLICATION_AUTHED_SCHOOL_LIST, result.data);
        }
    }
};
export default frontApp;